




















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import InputItem from '@/components/Money/InputItem.vue';
import Button from '@/components/Button.vue';

@Component({
    components: {Button, InputItem},

})
export default class EditLabel extends Vue {
    get tag() {
        return this.$store.state.currentTag;
    }

    created() {
        this.$store.commit('fetchTags');
        this.$store.commit('setCurrentTag', this.$route.params.id);
        if (!this.tag) {
            this.$router.replace('/404');
        }
    }

    updateTag(name: string) {
        if (this.tag) {
            this.$store.commit('updateTag', {id: this.tag.id, name});
        }
    }

    deleteTag() {
        if (!window.confirm('确定删除该标签吗？')) {
            return;
        }
        if (this.tag) {
            this.$store.commit('deleteTag', this.tag.id);
            window.alert('标签删除成功！');
            this.goBack();
        } else {
            window.alert('标签删除失败！');
        }
    }

    goBack() {
        this.$router.back();
    }
}
